import React from 'react';
import { Provider } from 'react-redux';
import { createStore as reduxCreateStore } from 'redux';
import rootReducer from './combineReducers';
import CookiesDisclaimer from '../components/global/cookies-disclaimer';

const createStore = () => reduxCreateStore(rootReducer);
// const createStore = () => reduxCreateStore(rootReducer, __REDUX_DEVTOOLS_EXTENSION__ && __REDUX_DEVTOOLS_EXTENSION__());

// CookiesDisclaimer sits at the root rather than inside Layout so it isn't
// unmounted and re-animated on every route change by gatsby-plugin-transition-link.
export default ({ element }) => (
  <Provider store={createStore()}>
    {element}
    <CookiesDisclaimer />
  </Provider>
);
